// The Agent Tasks tabs ARE the shared agent-task buckets — see lib/agent-task-buckets, the one source the
// workspace "Agents at work" stat cards bucket through too, so a card's count always equals what the tab
// it opens shows. This file only re-names them in tab terms for the screen.
export {
  visibleBuckets as visibleTaskTabs,
  clampToVisibleBucket as clampToVisibleTaskTab,
  bucketTasks,
  resolveInitialBucket,
  parseBucketParam,
  agentTasksAreEmpty,
} from '../../../lib/agent-task-buckets';
export type { AgentTaskBucket as TaskTab } from '../../../lib/agent-task-buckets';
import type { AgentTaskBucket } from '../../../lib/agent-task-buckets';

// The tabs the unified Tasks list renders: a leading catch-all `all` (every task, newest-updated first)
// plus the status buckets. `all` is a tab-level concern only — it is NOT a bucket, so it never touches the
// shared `AgentTaskBucket` (mirrored 1:1 with native).
export type TabKey = 'all' | AgentTaskBucket;
